export default "__VITE_ASSET__CxL0iHDK__"